import React from "react";

const Input = (props) => {
  return (
    <>
      <h2>{props.label}</h2>
      <input
        id={props.id}
        type="text"
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        inputMode="numeric"
        min="0"
      />
    </>
  );
};

export default Input;